<div class="container-fluid">
  <div class="row">
    <div class="col-3 align-self-end">
      <button class="btn btn-sm btn-info btn-flat pull-right margin" style="margin-top: 0px;"
        (click)="resetFilters()">Clear
        filters</button>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <form [formGroup]="form">
        <ngx-datatable appTableScrollHorizontal #mydatatable [cssClasses]="iconsCss" [externalSorting]="true"
          (sort)="onSort($event)" class="material striped server-scrolling-demo" [headerHeight]="headerHeight"
          [columnMode]="'force'" [loadingIndicator]="isLoading" [rowHeight]="rowHeight" [rows]="rows"
          [scrollbarV]="true" (scroll)="onScroll($event)">

          <ngx-datatable-column [sortable]="false" prop="index" name="{{'Sr No' | uppercase}}" [flexGrow]="0.5">
            <ng-template let-column="column" ngx-datatable-header-template>
              <p>{{column.name}}
              </p>
            </ng-template>

            <ng-template let-row="row" let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
              <strong>{{ rowIndex + 1}} </strong>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column  [sortable]="true"
            name="{{'Username' | uppercase}}" prop="name" [flexGrow]="1">

            <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
              <p (click)="sort()" style="cursor: pointer;">{{column.name}}
                <i [class]="getIcon(column.prop)" aria-hidden="true"></i>
              </p>
              <input type="text" class="form-control input-sm" placeholder="Filter by {{column.name | titlecase}}"
                formControlName="{{column.prop}}">
            </ng-template>

            <ng-template let-row="row" ngx-datatable-cell-template>
              <p>{{row.user_detail.first_name}} {{row.user_detail.last_name}}</p>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column [sortable]="true" name="{{'Plate Number' | uppercase}}" prop="vehicle_number"
            [flexGrow]="1">
            <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
              <p (click)="sort()" style="cursor: pointer;">{{column.name}}
                <i [class]="getIcon(column.prop)" aria-hidden="true"></i>
              </p>
              <input type="text" class="form-control input-sm" placeholder="Filter by {{column.name | titlecase}}"
                formControlName="{{column.prop}}">
            </ng-template>

            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
              <p>{{row.vehicle_detail.plate_number_prefix}} {{row.vehicle_detail.plate_number}}</p>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column [sortable]="true" name="{{'In Time' | uppercase}}" prop="in_time" [flexGrow]="1">
            <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
              <p (click)="sort()" style="cursor: pointer;">{{column.name}}
                <i [class]="getIcon(column.prop)" aria-hidden="true"></i>
              </p>
            </ng-template>

            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
              <p>{{value | date:'dd/MM/yyyy h:mm a'}}
                <span class="text-red">{{row.out_time ? "(exited)" : ""}}</span>
              </p>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </form>
    </div>
  </div>
</div>
